import { createEntityAdapter } from '@reduxjs/toolkit';
import { IEppComponent } from 'application/components/api/EppComponent';

export const eppComponentAdapter = createEntityAdapter<IEppComponent, number>({
  selectId: (project) => project.eppComponentID,
});
